import { useTranslation } from 'react-i18next';

import { SubscriptionOptions } from '../../../Forms/SubscriptionOptions/SubscriptionOptions';
import { SubscriptionItemBaseProps } from '../../SubscriptionItemForm/subscriptionItemForm.models';
import { useKidnapAndExtortionSubscriptionForm } from './kidnapAndExtortionSubscriptionForm.hooks';
import { Wrapper } from './kidnapAndExtortionSubscriptionForm.styles';
import { subscriptionOptions } from './kidnapAndExtortionSubscriptionForm.utils';
import SubscriptionPricingForm from './SubscriptionPricingForm/SubscriptionPricingForm';

const KidnapAndExtortionSubscriptionForm = ({
  name,
  disabled,
  className,
  isEditMode,
  contractType,
}: SubscriptionItemBaseProps) => {
  const { t } = useTranslation();
  useKidnapAndExtortionSubscriptionForm({ name, contractType });
  const options = subscriptionOptions(contractType);
  return (
    <Wrapper className={className}>
      <SubscriptionPricingForm
        name={name}
        disabled={disabled}
        isEditMode={isEditMode}
      />
      {options?.length !== 0 && (
        <SubscriptionOptions
          disabled={disabled}
          name={name}
          title={t('headers.options')}
          subscriptionOptions={options}
          layout="column"
        />
      )}
    </Wrapper>
  );
};

export default KidnapAndExtortionSubscriptionForm;
